var giphy_viewer_default = {
  "giphyWrapper": "_6AY8f",
  "giphy_player": "_27N5T",
  "playIcon": "yYVfJ",
  "gifRatio": "aTjbo"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
